// the view port  is a 19x19 grid, player at the center, of 32x32 pixel tiles
const TILE_SIZE: number = 32;
const VIEWPORT_TILES_WIDTH: number = 13;
const VIEWPORT_TILES_HEIGHT: number = 13;

const CANVAS_WIDTH: number = VIEWPORT_TILES_WIDTH * TILE_SIZE;
const CANVAS_HEIGHT: number = VIEWPORT_TILES_WIDTH * TILE_SIZE;

export { TILE_SIZE, VIEWPORT_TILES_WIDTH, VIEWPORT_TILES_HEIGHT, CANVAS_WIDTH, CANVAS_HEIGHT };
